import React, { useContext } from 'react'
import { RiUploadCloud2Fill } from 'react-icons/ri'
import { EditorContext } from '../../../../../../components/CanvasEditor/Context/EditorProvider'

const UploadPhoto = () => {

  const { editor } = useContext(EditorContext)
  const handleUpload = (e) => {
    let reader = new FileReader();
    reader.onload = (event) => {
      editor.addImage(event.target.result)
    }
    reader.readAsDataURL(e.target.files[0]);
  }

  return (
    <div className='upload-photo'>
      <div className='upload-photo-header'>
        <span><RiUploadCloud2Fill /></span>
      </div>
      <div className='file-upload-zone'>
        <input type='file' onChange={handleUpload} />
        <span className='click-or-drop'>Click Or Drop Image Here.</span>
      </div>
    </div>
  )
}

export default UploadPhoto